// contact-us — the storefront footer's "talk to a human" form.
//
// Distinct from `contact.ts` (the funnel's step one) on purpose: that flow
// captures a SHOPPER entering the quote funnel and creates a prospect; this one
// captures a QUESTION from anyone on any page — no funnel position, no meter,
// no prospect. The two must not share a schema, because the enquiry carries a
// free-text message and the lead deliberately never does.
//
// The email here is UNVERIFIED (no OTP on a footer form), so nothing may be
// auto-mailed to it; an operator reads the enquiry and decides how to reply.
import { z } from 'zod';
/**
 * The enquiry payload.
 *
 * Email reuses the funnel's RFC5321-ish bound. `name` is a single free field —
 * a footer form is not the place to force a first/last split on "Dr. A. Kumar
 * (landlord)". The message floor of 5 keeps "hi" out of the operator queue
 * without blocking a real short question.
 */
export const ContactUsRequestSchema = z
    .object({
    name: z.string().trim().min(2).max(120),
    email: z.string().email().max(254),
    message: z.string().trim().min(5).max(2000),
})
    .strict();
/**
 * The reply carries no personal data back — only that the enquiry was stored,
 * so the form can swap to its thank-you state.
 */
export const ContactUsResponseSchema = z
    .object({
    received: z.literal(true),
})
    .strict();
//# sourceMappingURL=contact-us.js.map